import {
    CREATE_PROCESS_SUPPLIER_REQUEST_DK,
    CREATE_PROCESS_SUPPLIER_SUCCESS_DK,
    CREATE_PROCESS_SUPPLIER_FAILURE_DK,
    DELETE_PROCESS_SUPPLIER_REQUEST_DK,
    DELETE_PROCESS_SUPPLIER_SUCCESS_DK,
    DELETE_PROCESS_SUPPLIER_FAILURE_DK,
    FETCH_SINGLE_PROCESS_SUPPLIER_REQUEST_DK,
    FETCH_SINGLE_PROCESS_SUPPLIER_SUCCESS_DK,
    FETCH_SINGLE_PROCESS_SUPPLIER_FAILURE_DK,
    FETCH_PROCESS_SUPPLIER_REQUEST_DK,
    FETCH_PROCESS_SUPPLIER_SUCCESS_DK,
    FETCH_PROCESS_SUPPLIER_FAILURE_DK,
    UPDATE_PROCESS_SUPPLIER_REQUEST_DK,
    UPDATE_PROCESS_SUPPLIER_SUCCESS_DK,
    UPDATE_PROCESS_SUPPLIER_FAILURE_DK,
    RESET_PROCESS_SUPPLIER_INFO_DK,
    CREATE_PROCESS_SUPPLIER_FORM_DK,
    UPDATE_PROCESS_SUPPLIER_FORM_DK
} from './processSupplier.actionsType';

export const PROCESS_SUPPLIER_DK = 'processSupplierDK';

let initialState = {
    loading: false,
    processSupplierList: [],
    processSupplierform: {},
    selectedState: {},
    errorMessage: ''
};

export let processSupplierDKReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_PROCESS_SUPPLIER_REQUEST_DK:
        case CREATE_PROCESS_SUPPLIER_REQUEST_DK:
        case UPDATE_PROCESS_SUPPLIER_REQUEST_DK:
        case FETCH_SINGLE_PROCESS_SUPPLIER_REQUEST_DK:
        case DELETE_PROCESS_SUPPLIER_REQUEST_DK:
            return {
                ...state,
                loading: true
            };
        case FETCH_PROCESS_SUPPLIER_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                processSupplierList: updatePayload
            };
        case CREATE_PROCESS_SUPPLIER_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                processSupplierform: {}
            };
        case UPDATE_PROCESS_SUPPLIER_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                processSupplierform: {}
            };
        case FETCH_SINGLE_PROCESS_SUPPLIER_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                processSupplierform: updatePayload
            };
        case DELETE_PROCESS_SUPPLIER_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                processSupplierform: {}
            };
        case RESET_PROCESS_SUPPLIER_INFO_DK:
            return {
                ...state,
                processSupplierform: {}
            };
        case CREATE_PROCESS_SUPPLIER_FORM_DK:
        case UPDATE_PROCESS_SUPPLIER_FORM_DK:
            return {
                ...state,
                loading: false,
                processSupplierform: {
                    ...state.processSupplierform,
                    [payload.key]: payload.value
                }
            };
        case FETCH_PROCESS_SUPPLIER_FAILURE_DK:
        case CREATE_PROCESS_SUPPLIER_FAILURE_DK:
        case UPDATE_PROCESS_SUPPLIER_FAILURE_DK:
        case FETCH_SINGLE_PROCESS_SUPPLIER_FAILURE_DK:
        case DELETE_PROCESS_SUPPLIER_FAILURE_DK:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
};
